import type { Locale } from 'date-fns';
import { DISPLAY_DATE_FORMAT, DISPLAY_DATE_FORMAT_SHORT } from 'src/common/constants';
import newTZDate, { formatDate } from 'src/common/utils/dateHelpers';

const getFormattedDates = (
  startDate: string,
  endDate: string,
  locale: Locale,
): string => {
  if (!startDate || !endDate) return '';
  const start = newTZDate(startDate);
  const end = newTZDate(endDate);
  const formattedStartDate = formatDate(start, DISPLAY_DATE_FORMAT, locale);
  const formattedEndDate = formatDate(end, DISPLAY_DATE_FORMAT, locale);

  const isSameYear = start.getFullYear() === end.getFullYear();
  const isSameMonth = start.getMonth() === end.getMonth();

  if (startDate === endDate) return formattedStartDate; // 12 Oct 2023
  if (!isSameYear) {
    return `${formattedStartDate} - ${formattedEndDate}`; // 12 Oct 2023 - 15 Nov 2024
  }
  if (isSameMonth) {
    return `${formatDate(start, 'dd')} - ${formattedEndDate}`; // 12 - 15 Oct 2023
  }
  return `${formatDate(start, DISPLAY_DATE_FORMAT_SHORT, locale)} - ${formattedEndDate}`; // 12 Oct - 15 Nov 2023
};

export default getFormattedDates;
